export default __webpack_public_path__ + "static/media/US BANK.2df7a9e6.svg";